import { useDoctorStore, DOCTORS_LOAD_ERROR } from '@/pinia-store/useDoctorStore'
import { useErrorToast } from '@/composables/useErrorToast'

/**
 * Aviso de falha na carga dos médicos da empresa para as abas Autorizados/Bloqueados.
 *
 * `fetchDoctors` não relança: a falha fica em `isError`/`errorMessage` da store (já
 * normalizada por `getApiErrorMessage`). Sem este aviso o seletor de médicos ficava
 * vazio, como se a empresa não tivesse nenhum. Chamar logo depois do fetch.
 */
export function useDoctorsLoadError() {
  const doctorStore = useDoctorStore()
  const { notifyErrorMessage } = useErrorToast()

  function notifyDoctorsLoadError(): void {
    if (doctorStore.isError) notifyErrorMessage(doctorStore.errorMessage ?? DOCTORS_LOAD_ERROR)
  }

  return { notifyDoctorsLoadError }
}
